/**
 * Created by toomasp on 29.07.2015.
 */
import {ViewportController} from './viewport.controller';

export let viewport = {
    template: require('./viewport.html'),
    controllerAs: 'viewport',
    controller: ViewportController
};


// WEBPACK FOOTER //
// ./src/main/ui/core/components/viewport/viewport.component.ts